module.exports = __webpack_public_path__ + "files/5eb4ffb12381469d0e831fa9b368dc23.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/custom.png
// module id = 1119
// module chunks = 60